"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ChainListener = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
class ChainListener {
  constructor(_ref) {
    let {
      api
    } = _ref;
    this.api = void 0;
    this.block$ = void 0;
    this.subscriptions = void 0;
    this.api = api;
    this.block$ = new _rxjs.ReplaySubject(1);
    this.subscriptions = [this.subscribeBlock().subscribe({
      next: data => this.block$.next(data)
    })];
  }
  static create(_ref2) {
    var _this$instances;
    let {
      api,
      key
    } = _ref2;
    const instanceKey = key || api.runtimeChain.toString();
    if ((_this$instances = this.instances) !== null && _this$instances !== void 0 && _this$instances[instanceKey]) return this.instances[instanceKey];
    const instance = new ChainListener({
      api
    });
    this.instances[instanceKey] = instance;
    return instance;
  }
  subscribeBlockRx() {
    const api = this.api;
    return api.rpc.chain.subscribeNewHeads().pipe((0, _operators.switchMap)(header => {
      const hash = header.hash.toString();
      return (0, _rxjs.from)(api.at(hash)).pipe((0, _operators.switchMap)(apiAt => {
        return (0, _rxjs.combineLatest)({
          block: api.rpc.chain.getBlock(hash),
          events: apiAt.query.system.events()
        });
      }));
    }), (0, _operators.map)(_ref3 => {
      let {
        block,
        events
      } = _ref3;
      const extrinsics = block.block.extrinsics.map((item, i) => {
        const ownedEvents = events.slice().filter(item => {
          if (item.phase.isInitialization && i === 0) return true;
          return item.phase.isApplyExtrinsic && item.phase.asApplyExtrinsic.eq(i);
        });
        return {
          raw: item,
          events: ownedEvents
        };
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
      const timestamp = new Date(Number(extrinsics[0].raw.args[0].toString()));
      return {
        block,
        extrinsics,
        events: [...events],
        timestamp
      };
    }));
  }
  subscribeBlockPromise() {
    const api = this.api;
    return new _rxjs.Observable(subscriber => {
      return (() => {
        api.rpc.chain.subscribeNewHeads(async header => {
          const hash = header.hash.toString();
          const block = await api.rpc.chain.getBlock(hash);
          const apiAt = await api.at(hash);
          const events = await apiAt.query.system.events();
          const extrinsics = block.block.extrinsics.map((item, i) => {
            const ownedEvents = events.slice().filter(item => {
              if (item.phase.isInitialization && i === 0) return true;
              return item.phase.isApplyExtrinsic && item.phase.asApplyExtrinsic.eq(i);
            });
            return {
              raw: item,
              events: ownedEvents
            };
          });

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
          const timestamp = new Date(Number(extrinsics[0].raw.args[0].toString()));
          subscriber.next({
            block,
            extrinsics,
            events: [...events],
            timestamp
          });
        });
      })();
    });
  }
  subscribeBlock() {
    if (this.api.type === 'promise') return this.subscribeBlockPromise();
    return this.subscribeBlockRx();
  }
  unsubscribe() {
    this.subscriptions.forEach(item => item.unsubscribe());
  }
  subscribeByEvents(configs) {
    return this.block$.pipe((0, _operators.map)(data => {
      const filter = (0, _sdkCore.eventsFilter)(configs);
      const extrinsics = data.extrinsics.filter(item => {
        return item.events.reduce((acc, cur) => {
          return acc || filter(cur);
        }, false);
      });
      const events = data.events.filter(item => {
        return filter(item);
      });
      return _objectSpread(_objectSpread({}, data), {}, {
        extrinsics,
        events
      });
    }), (0, _operators.filter)(data => {
      return data.events.length !== 0;
    }));
  }
}
exports.ChainListener = ChainListener;
ChainListener.instances = {};